import * as React from 'react';
import { Form, Modal, Input, Alert, Rate, Tag } from 'antd';
import { connect } from 'react-redux';
import PostCompletionQuestionnaire from '../PostCompletionQuestionnaire';
import { buyerGetQuestionnaire } from '../../thunks/work_orders_thunks';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import WorkOrderReviewComponent from '../WorkOrderReviewComponent';
import posthog from 'posthog-js';

const { Item: FormItem } = Form;

interface ApproveReviewWorkFormProps {
	onSubmit: any;
	onCancel: any;
	visible: boolean;
	createErrors: any;
	updateErrors: any;
	creating: boolean;
	updating: boolean;
	workOrderId: number;
	currentUser: any;
	onlyReview: boolean;
	getQuestionnaire: any;
	workOrder: any;
}

const ApproveReviewWorkForm: React.FC<ApproveReviewWorkFormProps> = (props) => {
	const {
		visible,
		onCancel,
		onSubmit,
		workOrderId,
		onlyReview,
		createErrors,
		updateErrors,
		creating,
		updating,
		getQuestionnaire,
		workOrder,
	} = props;
	const [form] = Form.useForm();
	const [loaded, setLoaded] = React.useState(false);
	const [questionnaire, setQuestionnaire] = React.useState({});

	const isAssignedToThirdParty = React.useMemo(() => {
		return (
			nullSafeGet('supplierFacilityId', workOrder) &&
			nullSafeGetOrElse('supplierFacility.status', workOrder, 'active') !== 'private'
		);
	}, [workOrder]);

	React.useEffect(() => {
		getQuestionnaire()
			.then((data = []) => {
				if (data.length) {
					setQuestionnaire(data[data.length - 1]);
				}
			})
			.finally(() => setLoaded(true));
	}, [getQuestionnaire]);

	if (!loaded) return null;

	if (nullSafeGet('questions.length', questionnaire)) {
		return (
			<PostCompletionQuestionnaire
				successCb={() => {
					onSubmit({ workOrderId, note: '' });
				}}
				onCancel={onCancel}
				questionsList={questionnaire}
				workOrderId={workOrderId}
				submitting={creating || updating}
			/>
		);
	}

	if (isAssignedToThirdParty)
		return (
			<WorkOrderReviewComponent
				successCb={() => {
					onSubmit({ workOrderId, note: '' });
				}}
				submitting={creating || updating}
				onCancel={onCancel}
				workOrder={workOrder}
				onlyReview={onlyReview}
			/>
		);

	return (
		<Modal
			visible={visible}
			width={600}
			title={onlyReview ? 'Review Work' : 'Approve Work'}
			okText={onlyReview ? 'Review' : 'Approve'}
			onCancel={onCancel}
			onOk={() => form.submit()}
			closable={false}
			confirmLoading={creating || updating}
		>
			<Form
				layout="vertical"
				className="supplierForm"
				form={form}
				onFinish={(values) => {
					onSubmit({ ...values, workOrderId });
				}}
			>
				{createErrors.length > 0 && (
					<FormItem>
						<Alert message={createErrors.join(' ')} type="error" />
					</FormItem>
				)}
				{updateErrors.length > 0 && (
					<FormItem>
						<Alert message={updateErrors.join(' ')} type="error" />
					</FormItem>
				)}
				<FormItem
					label="Review"
					name="note"
					rules={[{ required: onlyReview, message: 'This field is required.' }]}
				>
					<Input.TextArea autoSize />
				</FormItem>
			</Form>
		</Modal>
	);
};

const mapStateToProps = (state, ownProps) => ({
	visible: ownProps.visible,
	onCancel: ownProps.onCancel,
	onSubmit: ownProps.onSubmit,
	createErrors: state.work_orders.createErrors,
	updateErrors: state.work_orders.updateErrors,
	creating: state.work_orders.creating,
	updating: state.work_orders.updating,
	currentUser: state.session.currentUser,
	onlyReview: ownProps.onlyReview,
});

const mapDispatchToProps = (dispatch) => ({
	getQuestionnaire: (id) => dispatch(buyerGetQuestionnaire(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ApproveReviewWorkForm);
